class StringFurnitureApi extends HTMLElement {
  connectedCallback() {
    this.config = this.parseJson();
    this.boundMessageHandler = this.messageHandler.bind(this);
    window.addEventListener('message', this.boundMessageHandler, true);
  }

  disconnectedCallback() {
    window.removeEventListener('message', this.boundMessageHandler, true);
  }

  messageHandler(event) {
    if (event.data.event === 'byoLoaded') {
      this.handleLoad(event);
    }
    if (event.data.event === 'cartUpdate') {
      this.addToCart(event);
    }
    if (event.data.event === 'designUpdate') {
      this.handleUpdate(event);
    }
  }

  handleLoad(event) {
    this.querySelector('iframe').contentWindow.postMessage({ event: 'enableCart', data: {} }, '*');
  }

  findVariantBySku(sku) {
    return this.config.find((variant) => variant.sku === sku);
  }

  addToCart(event) {
    const cart = event.data.data.items;
    const items = cart
      .map((item) => ({
        id: this.findVariantBySku(item.article)?.id ?? '',
        quantity: item.quantity,
      }))
      .filter((item) => item.id !== '');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    }).then(() => {
      window.PXUTheme.jsAjaxCart.showDrawer();
      window.PXUTheme.jsAjaxCart.updateView();
    });
  }

  handleUpdate(event) {
    const cart = event.data.data.items;
    console.log('handleCart', cart);
  }

  parseJson() {
    try {
      return JSON.parse(document.querySelector('script[data-stringfurniture-api]').textContent);
    } catch {
      return [];
    }
  }
}

customElements.define('string-furniture-api', StringFurnitureApi);
